var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "invite-search-dia", class: [_vm.packageName] },
    [
      _c(
        "van-dialog",
        {
          attrs: {
            showConfirmButton: false,
            closeOnClickOverlay: "false",
            "lock-scroll": false,
          },
          on: { close: _vm.close },
          model: {
            value: _vm.showDia,
            callback: function ($$v) {
              _vm.showDia = $$v
            },
            expression: "showDia",
          },
        },
        [
          _vm.hostDate
            ? _c("div", { staticClass: "dialog" }, [
                _c("div", { staticClass: "avatar-name" }, [
                  _c("img", {
                    staticClass: "avatar",
                    attrs: {
                      src: _vm._f("imgPath")(_vm.hostDate.avatar),
                      alt: "",
                    },
                  }),
                  _c("div", { staticClass: "name-id" }, [
                    _c("span", { staticClass: "name" }, [
                      _vm._v(_vm._s(_vm.hostDate.nickname)),
                    ]),
                    _c("div", { staticClass: "id" }, [
                      _c("img", {
                        attrs: {
                          src: require("@/assets/packageAssets/views/P2_Page/Invite/vava/id_icon.png"),
                          alt: "",
                        },
                      }),
                      _vm._v(" " + _vm._s(_vm.hostDate.presentId) + " "),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.hostDate.title)),
                ]),
                _c("div", { staticClass: "content" }, [
                  _vm._v(" " + _vm._s(_vm.hostDate.content) + " "),
                ]),
                _c("div", { staticClass: "btns" }, [
                  _vm.hostDate.removable
                    ? _c(
                        "div",
                        {
                          staticClass: "btn btn1",
                          on: { click: _vm.handleRemove },
                        },
                        [_vm._v("Remove")]
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "btn", on: { click: _vm.handleOk } },
                    [_vm._v("OK")]
                  ),
                ]),
              ])
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }